module.exports = __webpack_public_path__ + "static/img/icon-download-blue.7c332d20.svg";